const THEME_KEY = 'obc_theme_preference'
export const THEME_DARK = 'dark'
export const THEME_LIGHT = 'light'

export function normalizeTheme(value) {
  return value === THEME_LIGHT ? THEME_LIGHT : THEME_DARK
}

export function getStoredTheme() {
  try {
    return normalizeTheme(localStorage.getItem(THEME_KEY))
  } catch {
    return THEME_DARK
  }
}

export function saveStoredTheme(theme) {
  const nextTheme = normalizeTheme(theme)

  try {
    localStorage.setItem(THEME_KEY, nextTheme)
  } catch {
    return nextTheme
  }

  return nextTheme
}
